import { useEffect, useState } from 'react';

import CheckboxComponent from './checkbox';

function Checkbox({
  name,
  label,
  icon,
  isEnabled,
  isChecked: initialIsChecked,
  className,
  style,
  onClick,
}) {
  const [isChecked, setChecked] = useState(initialIsChecked);

  useEffect(() => {
    setChecked(initialIsChecked);
  }, [initialIsChecked]);

  const handleClick = () => {
    const newChecked = !isChecked;
    setChecked(newChecked);
    onClick && onClick(newChecked);
  };

  return (
    <CheckboxComponent
      name={name}
      label={label}
      icon={icon}
      isEnabled={isEnabled}
      isChecked={isChecked}
      className={className}
      style={style}
      onClick={handleClick}
    />
  );
}

export default Checkbox;
